import React from 'react';
import PropTypes from 'prop-types';
import Section from 'helpers/Section';
import LogoFsBlue from 'assets/images/logo-fs-blue.svg';
import {cleanHtml} from 'helpers/commonHelper';
import LazyImage from 'helpers/LazyImage';
import {language, bookingBaseUrl} from 'helpers/stableValues';

const FerryPartner = ({translations}) => {
  const {partnershipWith, partnershipText} = translations;

  return(
    <Section
      sectionClass="py-4 bg-white border-top-solid"
      renderTitle={() => (
        <p className="text-lead d-flex">
          <i className="icon icon-handshake mb-1 mr-1"></i>
          {partnershipWith}
          <LazyImage
            imgClass="ml-1"
            src={LogoFsBlue}
            width="148"
            height="32"
            alt="ferryscanner"
            title="ferryscanner"
          />
        </p>
      )}
    >
      <p dangerouslySetInnerHTML={{
        __html: `${cleanHtml(partnershipText.replace('{url}', `//www.ferryscanner.com/${language}/${bookingBaseUrl}`))}`
      }}></p>
    </Section>
  );};

FerryPartner.propTypes = {
  translations: PropTypes.shape({
    partnershipWith: PropTypes.string.isRequired,
    partnershipText: PropTypes.string.isRequired
  })
};
export default FerryPartner;
